import { Injectable } from '@angular/core';
import { PaginatedResult } from 'src/app/shared/grid/paginate.model';
import { Observable } from 'rxjs';
import { IPaginatedServiceParamters } from '../core/models/ITable';
import { Contract } from '../core/models/Contract';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
 providedIn: 'root',
})
export class InstallmentsSchemasService {
 private loadingSubject = new BehaviorSubject<boolean>(false);
 public loading$ = this.loadingSubject.asObservable();

 constructor(private apiService: ApiService) {}

 getAllPaginated(
  paginatedArguments: IPaginatedServiceParamters,
): Observable<PaginatedResult<any>> {
  
  const cleanedParams: IPaginatedServiceParamters = {
    ...paginatedArguments
  };
  if (!cleanedParams.query) {
    cleanedParams.query = '';
  }
  
  
  this.loadingSubject.next(true);
  
  return this.apiService.getPaginated(
    '/api/Contract/ToDue',
    cleanedParams,
  ).pipe(
    finalize(() => this.loadingSubject.next(false))
  );
}
 getContractsToDue(filters: {
 pageNumber?: number;
 pageSize?: number;
 contractType?: string; 
 status?: string;        
 agencyId?: number;
}): Observable<PaginatedResult<any>> {
   
 
   const params: IPaginatedServiceParamters = {
     query: '',
     pageNumber: filters.pageNumber || 1,
     pageSize: filters.pageSize || 10,
     period: 1,
     id: filters.agencyId || 0
   };

   if (filters.contractType && filters.contractType !== 'all') {
     const typeMap: {[key: string]: number} = {
       'vivienda2019': 1,       
       'vivienda2023': 3,
       'vivienda2024': 4,       
       'comercial': 2         
     };
     
     if (typeMap[filters.contractType]) {
       params.installmentTypeId = typeMap[filters.contractType];
     }
   }

   if (filters.status && filters.status !== 'all') {
   const statusMap: {[key: string]: number} = {
     'expired': -1,       
     'thisMonth': 0,     
     'nextMonth': 1,      
     'threeMonths': 2   
   };

   if (statusMap[filters.status] !== undefined) {
     params.expiryStatus = statusMap[filters.status];
   }
 }

   
   this.loadingSubject.next(true);
   
   return this.apiService.getPaginated('/api/Contract/ToDue', params).pipe(
     finalize(() => this.loadingSubject.next(false))
   );
 }

 addInstallmentSchema(contractArray, amount, quantity) {
   const contractIds = Array.isArray(contractArray)
     ? contractArray
     : [contractArray];

   const installmentSchema = {
     contractIds: contractIds,
     newAmount: amount,
     installmentQuantity: quantity,
   };

   this.loadingSubject.next(true);

   return this.apiService.post(
     `/api/Contract/AddInstallmentSchema`,
     installmentSchema,
   ).pipe(
     finalize(() => this.loadingSubject.next(false))
   );
 }
}